import React from 'react';

import LoadingIcon from 'icons/loading.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

import { useCurrentActor } from 'components/contexts/CurrentActor';

export default function DuplicationInProgressModal({
  onClose,
  originalProject,
}) {
  const {
    division: {
      attributes: { singularRAMSName },
    },
  } = useCurrentActor();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectsDashboard.components.DuplicationInProgressModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <ModalBox
      isOpen={true}
      mode='letterbox'
      onClose={onClose}
      withFooter={false}
    >
      <>
        <h2 className='modalbox-header__title truncated-text-container tw-border-0 tw-border-b-1 tw-border-solid tw-border-grey-100 tw-p-6 tw-text-xl tw-font-semibold tw-text-grey-900'>
          {i18nTShared('duplicateName', {
            interpolation: { escapeValue: false },
            name: originalProject.attributes.name,
          })}
        </h2>
        <div className='modalbox-body tw-flex tw-flex-col tw-items-center tw-py-6'>
          <span className='tw-apply-loading-spinner--blue-light tw-py-6'>
            <LoadingIcon height={48} width={48} />
          </span>
          <div className='tw-pb-4 tw-text-l tw-font-semibold tw-text-grey-900'>
            {i18nT('description', {
              interpolation: { escapeValue: false },
              singularRAMSName,
            })}
          </div>
          <div className='tw-w-full tw-pb-6 tw-text-center'>
            {i18nT('disclaimer')}
          </div>
        </div>
        <div className='action-modal__footer tw-border-grey-100'>
          <TextButton color='blue' onClick={onClose} size='md'>
            {i18nTShared('close')}
          </TextButton>
        </div>
      </>
    </ModalBox>
  );
}

DuplicationInProgressModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  originalProject: PropTypes.object.isRequired,
};
